import React from "react";

import { RealizationKpi } from "./RealizationStatics/RealizationCards.js";
import { LobRealization } from "./RealizationStatics/LobRealization.js";
import { BarRealization } from "./RealizationStatics/BarChartRealization.js";
import NfaRegionCombined from "./RealizationStatics/NfaRegionCombined.jsx";
import { NfaApproved } from "./RealizationStatics/NfaApproved";

const Realization = () => {
  return (
    <div className="flex flex-col flex-grow w-full">
      {/* KPI Section */}
      <div className="px-2 mt-2">
        <RealizationKpi />
      </div>

      {/* Main Layout */}
      <div className="px-2 mt-2 mb-2 grid grid-cols-1 lg:grid-cols-4 gap-2">
        {/* LEFT SIDE (75%) */}
        <section className="lg:col-span-3 flex flex-col gap-2">
          {/* Bar Chart */}
          <div className="bg-white rounded-md w-full">
            <BarRealization />
          </div>

          {/* Bottom Two Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <div className="bg-white rounded-md w-full">
              <NfaRegionCombined />
            </div>

            <div className="bg-white rounded-md w-full">
              <NfaApproved />
            </div>
          </div>
        </section>

        {/* RIGHT SIDE (25%) */}
        <section className="lg:col-span-1 w-full">
          <LobRealization />
        </section>
      </div>
    </div>
  );
};

export default Realization;
